var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.959 15.708a1.208 1.208 0 00-1.209 1.209v.459l-1.788-1.789a3.371 3.371 0 00-4.749 0l-.846.846-2.996-2.996a3.443 3.443 0 00-4.749 0l-1.788 1.788V8.458A1.208 1.208 0 016.042 7.25H14.5a1.208 1.208 0 100-2.417H6.042a3.625 3.625 0 00-3.625 3.625v14.5a3.625 3.625 0 003.625 3.625h14.5a3.625 3.625 0 003.625-3.625v-6.041a1.208 1.208 0 00-1.208-1.209zM6.042 24.167a1.208 1.208 0 01-1.208-1.209v-4.313l3.504-3.505a.954.954 0 011.317 0l3.83 3.83 5.196 5.197H6.042zm15.708-1.209a1.075 1.075 0 01-.217.64l-5.45-5.473.846-.846a.928.928 0 011.33 0l3.491 3.516v2.163zm5.692-17.774l-3.625-3.625a1.208 1.208 0 00-.4-.254 1.208 1.208 0 00-.918 0 1.21 1.21 0 00-.398.254l-3.625 3.625A1.213 1.213 0 0020.192 6.9l1.558-1.571v6.754a1.208 1.208 0 102.417 0V5.33l1.559 1.57a1.209 1.209 0 001.716 0 1.21 1.21 0 000-1.715z",
    fill: "#6C5AFC"
  })));
}

export default SvgUploadMobile;